import { DummyStore } from 'stores';

const editorSettingsStore = new DummyStore<string[]>([]);
const receiptSettingsStore = new DummyStore<ReceiptSettingsType>({});
const organizerStore = new DummyStore<OrganizerType>();

export { editorSettingsStore, receiptSettingsStore, organizerStore };
export const LOAD_FORM = 'RACES_LOAD_FORM';
